import * as React from 'react'

import { Icon } from '~/components/icon/Icon'
import { Tree } from '~/components/tree/Tree'
import { styled } from '~/styled'

const StyledItemContent = styled('label', {
  base: ['max-w-full', 'flex', 'items-center', 'gap-2']
})

type CheckboxTreeItemContentProps = React.ComponentProps<
  typeof StyledItemContent
>

export const CheckboxTreeItemContent = ({
  children,
  ...rest
}: CheckboxTreeItemContentProps): React.JSX.Element => {
  return (
    <StyledItemContent {...rest}>
      {
        React.Children.map(children, (child) => {
          if (typeof child === 'string' || typeof child === 'number') {
            return <Tree.Text>{child}</Tree.Text>
          }
          if (
            React.isValidElement<React.ComponentPropsWithoutRef<typeof Icon>>(
              child
            ) &&
            child.type === Icon
          ) {
            return <Tree.Icon {...child.props} />
          }
          return child
        }) as React.ReactElement<unknown>[]
      }
    </StyledItemContent>
  )
}
